var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormControl, IconButton, Popover, Stack } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterRuleRow from "../filters/FilterRuleRow";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import FilterRuleSimplePreview from "./FilterRuleSimplePreview";
import AddIcon from "@mui/icons-material/Add";
var FilterSelect = function (_a) {
    var filterOptions = _a.filterOptions, filterRules = _a.filterRules, setFilterRules = _a.setFilterRules, forceSectorId = _a.forceSectorId, rightHandSideSearch = _a.rightHandSideSearch, anchorElementRef = _a.anchorElementRef, closeDrawer = _a.closeDrawer;
    var t = useTranslation().t;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React.useState({}), tmpFilterRule = _c[0], setTmpFilterRule = _c[1];
    var _d = React.useState(0), selectedIndex = _d[0], setSelectedIndex = _d[1];
    var _e = React.useState(false), canShowAddFilter = _e[0], setCanShowAddFilter = _e[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        setTmpFilterRule({});
        setSelectedIndex(-1);
    };
    useEffect(function () {
        // Workaround to make filter popover appear on first click
        // Then show 'add filters'
        if (rightHandSideSearch && (anchorElementRef === null || anchorElementRef === void 0 ? void 0 : anchorElementRef.current) && filterRules.length < 1) {
            setAnchorEl(anchorElementRef === null || anchorElementRef === void 0 ? void 0 : anchorElementRef.current);
            setTmpFilterRule({});
            setSelectedIndex(-1);
            // Fix: Check if ref exists before assigning
            if (anchorElementRef) {
                anchorElementRef.current = undefined;
            }
        }
    }, [rightHandSideSearch, anchorElementRef === null || anchorElementRef === void 0 ? void 0 : anchorElementRef.current]);
    var handleExistingFilterClick = function (event, index) {
        setAnchorEl(event.currentTarget);
        setTmpFilterRule(filterRules[index]);
        setSelectedIndex(index);
    };
    var handleClose = function () {
        setAnchorEl(null);
        setCanShowAddFilter(true);
    };
    var handleCloseWithCloseDrawer = function () {
        setCanShowAddFilter(false);
        setAnchorEl(null);
        closeDrawer === null || closeDrawer === void 0 ? void 0 : closeDrawer();
    };
    var open = Boolean(anchorEl);
    var id = open ? 'filter-popover' : undefined;
    var renderAddFilter = function () {
        if (!rightHandSideSearch) {
            // Old approach
            return ((_jsx(IconButton, __assign({ onClick: handleClick }, { children: _jsx(FilterAltIcon, { color: "secondary" }) }))));
        }
        return ((canShowAddFilter || filterRules.length > 0) ? (_jsx(Button, __assign({ onClick: handleClick, startIcon: _jsx(AddIcon, {}) }, { children: t('Add filter') }))) : null);
    };
    return (_jsxs(FormControl, __assign({ sx: { position: 'relative' } }, { children: [_jsxs(Stack
            // Changing the stack direction as the sidebar is quite narrow, so the filter rules preview can use the full width
            , __assign({ 
                // Changing the stack direction as the sidebar is quite narrow, so the filter rules preview can use the full width
                direction: rightHandSideSearch ? 'column' : 'row', gap: 2, alignItems: 'center' }, { children: [filterRules.map(function (rule, index) {
                        return (_jsx(FilterRuleSimplePreview, { rule: rule, index: index, filterOptions: filterOptions, filterRules: filterRules, setFilterRules: setFilterRules, handleExistingFilterClick: handleExistingFilterClick }, index));
                    }), renderAddFilter()] })), _jsx(Popover, __assign({ id: id, open: open, anchorEl: anchorEl, onClose: handleCloseWithCloseDrawer, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }, sx: {
                    ml: -5.5,
                    mt: -3.5
                } }, { children: _jsxs(Stack, __assign({ sx: {
                        width: 600,
                        boxSizing: 'border-box',
                        p: 2
                    } }, { children: [_jsx(FilterRuleRow, { filterOptions: filterOptions, filterRule: tmpFilterRule, setFilterRule: function (filterRule) {
                                setTmpFilterRule(filterRule);
                            }, index: 0, direction: 'column', sx: {
                                width: '100%'
                            }, forceSectorId: forceSectorId }), _jsx(Button, __assign({ size: 'small', onClick: function () {
                                if (selectedIndex >= 0) {
                                    var newFilterRules = __spreadArray([], filterRules, true);
                                    newFilterRules[selectedIndex] = tmpFilterRule;
                                    setFilterRules(newFilterRules);
                                }
                                else {
                                    setFilterRules(__spreadArray(__spreadArray([], filterRules, true), [tmpFilterRule], false));
                                }
                                handleClose();
                            }, color: 'primary', sx: {
                                mt: 3
                            }, variant: 'contained' }, { children: selectedIndex >= 0 ? t('Update filter') : t('Add filter') }))] })) }))] })));
};
export default FilterSelect;
